import { memo } from 'react';
import { View, Text } from 'react-native';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentCase } from '../cases/selector';

import AirmanHome from '../airforce/airman_home';

export default memo(function MilPatientHome(props) {
  const currentCaseObj = useSelector((state) => getCurrentCase(state));
  if (!currentCaseObj) return null;
  return <AirmanHome screenVisible={props.screenVisible} currentCaseObj={currentCaseObj} />;
});
